// REMIX HMR BEGIN
if (!window.$RefreshReg$ || !window.$RefreshSig$ || !window.$RefreshRuntime$) {
  console.warn('remix:hmr: React Fast Refresh only works when the Remix compiler is running in development mode.');
} else {
  var prevRefreshReg = window.$RefreshReg$;
  var prevRefreshSig = window.$RefreshSig$;
  window.$RefreshReg$ = (type, id) => {
    window.$RefreshRuntime$.register(type, "\"app\\\\components\\\\AppFooter.tsx\"" + id);
  }
  window.$RefreshSig$ = window.$RefreshRuntime$.createSignatureFunctionForTransform;
}
import * as __hmr__ from "remix:hmr";
if (import.meta) {
  import.meta.hot = __hmr__.createHotContext(
  //@ts-expect-error
  "app\\components\\AppFooter.tsx");
  import.meta.hot.lastModified = "1757171103287.8894";
}
// REMIX HMR END

import { ChevronUp } from "lucide-react";
import { Link } from "@remix-run/react";
import { Button } from "./ui/button";
export function AppFooter() {
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  };
  const aboutLinks = [{
    label: "Join Our Team",
    href: "/about"
  }, {
    label: "Investors",
    href: "/investors"
  }, {
    label: "Partners",
    href: "/partners"
  }];
  const socialLinks = [{
    label: "X",
    href: "https://twitter.com/nomadicstudios"
  }, {
    label: "Facebook",
    href: "https://facebook.com/nomadicstudios"
  }, {
    label: "LinkedIn",
    href: "https://linkedin.com/company/nomadic-studios"
  }, {
    label: "Instagram",
    href: "https://instagram.com/nomadicstudios"
  }];
  const footerLinks = [{
    label: "Terms & Conditions",
    href: "/terms"
  }, {
    label: "Privacy Policy",
    href: "/privacy"
  }];
  return <footer className="bg-black text-white">
      <div className="px-4 lg:px-14 py-6 lg:py-10">
        {/* Desktop Layout */}
        <div className="hidden lg:block">
          <div className="flex items-start justify-between">
            {/* Logo */}
            <div className="flex-shrink-0">
              <Link to="/" className="block">
                <img src="/images/logo-white.png" alt="Nomadic Studios" className="h-12 w-auto" />
              </Link>
            </div>

            {/* Navigation Sections */}
            <div className="flex justify-between w-full max-w-[520px]">
              {/* About Links */}
              <div>
                <h3 className="text-heading-5 !text-white/60 mb-6">About</h3>
                <nav className="space-y-4">
                  {aboutLinks.map(link => <Link key={link.href} to={link.href} className="block text-white hover:text-white/70 transition-colors text-sm uppercase tracking-[0.02em]">
                      {link.label}
                    </Link>)}
                </nav>
              </div>

              {/* Social Media */}
              <div>
                <h3 className="text-heading-5 !text-white/60 mb-6">
                  Social Media
                </h3>
                <nav className="space-y-4">
                  {socialLinks.map(link => <a key={link.href} href={link.href} target="_blank" rel="noopener noreferrer" className="block text-white hover:text-white/70 transition-colors text-sm uppercase tracking-[0.02em]">
                      {link.label}
                    </a>)}
                </nav>
              </div>
            </div>
          </div>

          {/* Bottom Row */}
          <div className="flex items-center justify-between mt-16 pt-8 border-t border-white/10">
            {/* Back to Top */}

            <Button onClick={scrollToTop} variant="outline-white" size="md" className="text-footer-bottom border-white !text-white hover:bg-white hover:!text-black px-8 py-3">
              Back to Top
              <ChevronUp className="ml-2 h-4 w-4" />
            </Button>

            <div className="flex items-center gap-8">
              <p className="text-footer-bottom text-white/60">
                ©2025 Nomadic Studios
              </p>
              {footerLinks.map(link => <Link key={link.href} to={link.href} className="text-footer-bottom text-white/60 hover:text-white transition-colors">
                  {link.label}
                </Link>)}
              <div className="flex items-center gap-2">
                <span className="text-footer-bottom text-white/60">
                  ENG (USD)
                </span>
                <ChevronUp className="h-3 w-3 text-white/60 rotate-180" />
              </div>
            </div>
          </div>
        </div>

        {/* Mobile Layout */}
        <div className="lg:hidden">
          {/* Logo */}
          <div className="mb-12">
            <Link to="/" className="block w-fit">
              <img src="/images/logo-white.png" alt="Nomadic Studios" className="h-10 w-auto" />
            </Link>
          </div>

          {/* About Section */}
          <div className="mb-12">
            <h3 className="text-heading-5 !text-white/60 mb-6">About</h3>
            <nav className="space-y-6">
              {aboutLinks.map(link => <Link key={link.href} to={link.href} className="block text-white text-lg uppercase tracking-[0.02em]">
                  {link.label}
                </Link>)}
            </nav>
          </div>

          {/* Social Media Section */}
          <div className="mb-12">
            <h3 className="text-heading-5 !text-white/60 mb-6">Social Media</h3>
            <nav className="space-y-6">
              {socialLinks.map(link => <a key={link.href} href={link.href} target="_blank" rel="noopener noreferrer" className="block text-white text-lg uppercase tracking-[0.02em]">
                  {link.label}
                </a>)}
            </nav>
          </div>

          {/* Copyright */}
          <div className="space-y-6 mb-12">
            {footerLinks.map(link => <Link key={link.href} to={link.href} className="block text-white/60 text-footer-bottom uppercase tracking-[0.02em]">
                {link.label}
              </Link>)}
            <div className="flex items-center gap-2">
              <span className="text-white/60 text-footer-bottom uppercase tracking-[0.02em]">
                ENG (USD)
              </span>
              <ChevronUp className="h-4 w-4 text-white/60 rotate-180" />
            </div>
            <p className="text-footer-bottom text-white/60">
              ©2025 Nomadic Studios
            </p>
          </div>

          {/* Back to Top Button */}
          <div className="flex justify-center">
            <Button onClick={scrollToTop} variant="outline-white" size="lg" className="text-footer-bottom border-white !text-white hover:bg-white hover:!text-black px-8 py-4 w-full">
              Back to Top
              <ChevronUp className="ml-2 h-5 w-5" />
            </Button>
          </div>
        </div>
      </div>
    </footer>;
}
_c = AppFooter;
var _c;
$RefreshReg$(_c, "AppFooter");

window.$RefreshReg$ = prevRefreshReg;
window.$RefreshSig$ = prevRefreshSig;